import { createUseSessionIdSync } from '@repo/observability/analytics-consent'
import { ANALYTICS_OPTED_OUT_COOKIE } from '@repo/observability/session'
import { cookies } from '@repo/utils'

import { setClientSessionId } from '@/lib/observability/logger'

import { isAnalyticsOptedOut } from '../consent'
import { setAnalyticsSessionId } from '../session-id'

// The cookie is what the server checks, and it is still written when localStorage is unavailable.
const isSessionIdOptedOut = () =>
  isAnalyticsOptedOut() || cookies.get(ANALYTICS_OPTED_OUT_COOKIE) !== undefined

/**
 * Bridges the HttpOnly `mo-session-id` cookie (read server-side, exposed via
 * `SessionIdProvider`) to PostHog as the `session_id` session property, and to
 * client-side BetterStack events as `context.sessionId`.
 */
export const useSessionIdSync = createUseSessionIdSync(sessionId => {
  setAnalyticsSessionId(sessionId)
  setClientSessionId(sessionId, isSessionIdOptedOut)
})
